import { render, staticRenderFns } from "./smallPackageDistribute.vue?vue&type=template&id=5a9dbc3e&scoped=true"
import script from "./smallPackageDistribute.vue?vue&type=script&lang=js"
export * from "./smallPackageDistribute.vue?vue&type=script&lang=js"
import style0 from "./smallPackageDistribute.vue?vue&type=style&index=0&id=5a9dbc3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6.0_webpack@4.47.0___2141a494b913d03a9170cbed536032b7/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9dbc3e",
  null
  
)

export default component.exports